import { render } from "./ChartIcon.vue?vue&type=template&id=1e36ab10&scoped=true"
const script = {}

import "./ChartIcon.vue?vue&type=style&index=0&id=1e36ab10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e36ab10"]])

export default __exports__